import { TypePlayGeniusOrder } from '@/lib/api/orderManager/types/TypePlayGeniusOrder';
import { TypeProduct } from '@/core/generated-types/TypeProduct';
import { TypeExternalPaymentMethod } from '@/lib/api/productCatalog/types';

import { TypeDecoratedSubEngineSubscription } from '@/lib/api/subscriptionManager/decorators/subEngine/decorateSubEngineSubscriptions';

import {
  SubEngineInstallmentStatusEnum,
  TypeSubEngineInstallment,
} from '@/lib/api/subscriptionManager/types';

import {
  CLICKED_ITEM_TYPES,
  CTA_NAMES,
  PAGE_LOCATIONS,
  trackItemClickedEvent,
} from '@/utils/rudderstack';

type TypeERCBox = {
  orderData?: TypePlayGeniusOrder;
  installmentData?: TypeSubEngineInstallment;
  productData?: TypeProduct;
  paymentMethodData?: TypeExternalPaymentMethod;
};

export type TypeERCUpcomingBox = {
  installmentData: TypeSubEngineInstallment;
  productData: TypeProduct;
};

export type GetErcBoxesParams = {
  subscription: TypeDecoratedSubEngineSubscription;
  orders?: TypePlayGeniusOrder[];
  draftOrder?: TypePlayGeniusOrder;
  contentfulProductsObject: Record<string, TypeProduct>;
};

export function getErcBoxes({
  subscription,
  orders,
  draftOrder,
  contentfulProductsObject,
}: GetErcBoxesParams) {
  const latestOrderedInstallment = subscription.installments.findLast(
    ({ status }) => status === SubEngineInstallmentStatusEnum.ORDERED,
  );

  const order = orders?.find(
    ({ playgenius_order_id }) =>
      playgenius_order_id === latestOrderedInstallment?.order_id,
  );

  const currentBoxProduct = latestOrderedInstallment?.product_anchor
    ? contentfulProductsObject[latestOrderedInstallment.product_anchor]
    : ({} as TypeProduct);

  const currentBox: TypeERCBox = {
    orderData: order,
    installmentData: latestOrderedInstallment,
    productData: currentBoxProduct,
  };

  const scheduledInstallments = subscription.installments.filter(
    ({ status }) => status === SubEngineInstallmentStatusEnum.SCHEDULED,
  );

  const [nextOrderInstallment, ...upcomingBoxesInstallments] =
    scheduledInstallments;

  const nextOrderProduct = nextOrderInstallment?.product_anchor
    ? contentfulProductsObject[nextOrderInstallment.product_anchor]
    : ({} as TypeProduct);

  const nextOrder: TypeERCBox = {
    orderData: draftOrder,
    installmentData: nextOrderInstallment,
    productData: nextOrderProduct,
    paymentMethodData: subscription.paymentMethod,
  };

  const upcomingBoxes: TypeERCUpcomingBox[] = upcomingBoxesInstallments.map(
    (installment) => {
      const product = contentfulProductsObject[installment.product_anchor];

      return {
        installmentData: installment,
        productData: product,
      };
    },
  );

  return { currentBox, nextOrder, upcomingBoxes };
}

// rudderstack click events for the Early Reader Club Page
export const trackClickEvent = (cta: CTA_NAMES) => {
  trackItemClickedEvent({
    url: window.location.href,
    type: CLICKED_ITEM_TYPES.LINK,
    pageLocation: PAGE_LOCATIONS.EARLY_READER_CLUB_PAGE,
    cta: cta,
  });
};
